import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsFullWidthContentLayout } from 'modules/settings/components/settings-fullwidth-content-layout/settings-fullwidth-content-layout.component';
import { SettingsDevicesPredefinedCommentsListContainer } from '../settings-devices-predefined-comments-list/settings-devices-predefined-comments-list.container';
import { PredefinedCommentsBulkActionsContainer } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-bulk-actions/predefined-comments-bulk-actions.container';
import { PredefinedCommentsListProvider } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/providers/predefined-comments-list.provider';
import { usePredefinedCommentNavigation } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-predefined-comment-navigation.hook';

export const SettingsDevicesPredefinedCommentsDashboardContainer = () => {
    const { t } = useTranslation();
    const { navigateToNew } = usePredefinedCommentNavigation();

    return (
        <PredefinedCommentsListProvider>
            <SettingsFullWidthContentLayout
                title={t('settings.devices.predefined-comments.title')}
                description={t('settings.devices.predefined-comments.subtitle')}
                actionsContent={
                    <PocButton variant="secondary" onClick={navigateToNew}>
                        <PocIcon slot="prefix" name="circle_add" />
                        {t('settings.devices.predefined-comments.action.add')}
                    </PocButton>
                }
                extraContent={<PredefinedCommentsBulkActionsContainer />}
            >
                <SettingsDevicesPredefinedCommentsListContainer />
            </SettingsFullWidthContentLayout>
        </PredefinedCommentsListProvider>
    );
};
